/** Leads → Bookings view (`/w/:ws/leads?view=bookings`), engage group. */
export const bookings = {
  title: "Bookings",
  tabs: {
    label: "Filter bookings by status",
    all: "All",
    requested: "Requested",
    confirmed: "Confirmed",
    declined: "Declined",
    cancelled: "Cancelled",
  },
  waiting_one: "{{count}} request is waiting for your answer.",
  waiting_other: "{{count}} requests are waiting for your answer.",
  showRequested: "Show requests",
  columns: {
    when: "When",
    service: "Service",
    visitor: "Visitor",
    owner: "Owner",
    status: "Status",
    actions: "Actions",
  },
  visitorTime: "Visitor's time: {{time}} ({{zone}})",
  party_one: "{{count}} person",
  party_other: "{{count}} people",
  phoneEnding: "Phone ending {{digits}}",
  note: "Note: {{note}}",
  decisionNote: "Your note: {{note}}",
  status: {
    requested: "Requested",
    confirmed: "Confirmed",
    declined: "Declined",
    cancelled: "Cancelled",
    pending: "Reserving",
    failed: "Failed",
  },
  mode: {
    calendar: "Booked in Google Calendar",
    request: "Request",
  },
  openCalendar: "Open in Google Calendar",
  joinMeet: "Google Meet link",
  openLead: "Open lead",
  confirm: "Confirm",
  decline: "Decline",
  confirmLabel: "Confirm the booking of {{name}}",
  declineLabel: "Decline the booking of {{name}}",
  cancel: "Cancel booking",
  cancelLabel: "Cancel the booking of {{name}}",
  decision: {
    confirmTitle: "Confirm this booking?",
    declineTitle: "Decline this booking?",
    confirmBody: "{{name}} · {{when}}. The visitor gets a confirmation email.",
    declineBody: "{{name}} · {{when}}. The visitor gets an email saying this time isn't available.",
    noteLabel: "Note (optional)",
    confirmHint: "Saved on the booking. It isn't sent to the visitor.",
    declineHint: "Included in the email to the visitor, so keep it polite.",
    tooLong: "Keep the note under {{count}} characters.",
    submitConfirm: "Confirm booking",
    submitDecline: "Decline booking",
    cancelTitle: "Cancel this booking?",
    cancelBody: "{{name}} · {{when}}. The time is freed, the Google Calendar event is removed if there is one, and the visitor gets an email.",
    cancelHint: "Included in the email to the visitor, so keep it polite.",
    submitCancel: "Cancel booking",
    keep: "Keep booking",
  },
  confirmed: "Booking confirmed for {{name}}",
  declined: "Booking declined for {{name}}",
  cancelled: "Booking cancelled for {{name}}",
  readOnly: "You can see bookings. Confirming, declining or cancelling needs permission to edit leads.",
  empty: {
    title: "No bookings yet",
    filtered: "No {{status}} bookings",
    body: "When the assistant books a visit or an appointment, it shows up here. Set your opening hours on a booking action so visitors can be offered times.",
    filteredBody: "Try another status to see more.",
    cta: "Set up availability",
    showAll: "Show all bookings",
  },
  loadError: "Bookings couldn't load.",
  showing: "Showing {{shown}} bookings",
} as const;
